import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

class ModalAddAnotherSubject extends Component {
    state = {
        name: '',
        slug: '',
        duration: 0,
        description: '',
        img: ''
    };

    //Renders
    renderModalHeader = () => (
        <div className="modal-header">
            <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.resetState}
            >
                <span aria-hidden="true">
                    &times;
                </span>
            </button>
            <h4
                className="modal-title"
                id="myModalLabel"
            >
                Add Subject
            </h4>
        </div>
    );

    renderModalFooter = () => (
        <div className="modal-footer">
            <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
                onClick={() => this.resetState()}
            >
                Close
            </button>
            <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={()=>
                    {
                        this.props.addNewSubject(this.state);
                        this.resetState()
                    }
                }
            >
                Save changes
            </button>
        </div>
    );

    renderInputs = (title, placeholder, value) => (
        <div>
            <div className="form-group">
                <label>{title}</label>
                <input
                    type="text"
                    className="form-control"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e)=> this.onChangeStateSubjectName(e)}
                />
            </div>
            <div className="form-group">
                <label>Slug</label>
                <input
                    type="text"
                    className="form-control"
                    placeholder={"Slug (URI)"}
                    value={this.state.slug}
                    onChange={e => {
                        this.setState({slug: e.target.value});
                    }}
                />
            </div>
            <div className="form-group">
                <label>Expected duration (in days)</label>
                <input
                    type="number"
                    className="form-control"
                    placeholder="Enter number"
                    value={this.state.duration}
                    onChange={(e) => {
                        this.setState({duration: e.target.value});

                    }} />
            </div>
        </div>
    );

    renderTextArea = (placeholder, value) => (
        <div className="form-group">
            <label>Description</label>
            <textarea
                className="form-control"
                rows="5"
                placeholder={placeholder}
                value={value}
                onChange={(e)=> this.onChangeStateDescription(e)}
            >
            </textarea>
        </div>
    );

    //Actions
    onChangeStateDescription = (e) => {
        this.setState({
            description: e.target.value
        })
    };

    onChangeStateSubjectName = (e) => {

        let slug = e.target.value.toString().toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(/[^\w-]+/g, '') // Remove all non-word chars
            .replace(/-+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, '');

        this.setState({name: e.target.value, slug: slug})
    }

    onDrop(files) {
        this.setState({
            img: files
        });
    }
    resetState = () => (
        this.setState({
            name: '',
            slug: '',
            description: '',
            img: ''
        })
    );

    render() {


        return (
            <div
                className="modal fade"
                id="AddAnotherSubject"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="myModalLabel"
            >
                <div
                    className="modal-dialog"
                    role="document"
                >
                    <div className="modal-content">
                        {this.renderModalHeader()}
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    {this.renderInputs('Subject Name', 'Name', this.state.name)}
                                    {this.renderTextArea('Description', this.state.description)}
                                </div>
                                <div className="col-sm-6">
                                    <Dropzone
                                        accept="image/jpeg, image/png"
                                        onDrop={this.onDrop.bind(this)}
                                    >
                                        {
                                            this.state.img
                                                ? <img src={this.state.img[0].preview} alt=""/>
                                                : <p>Try dropping some files here, or click to select files to upload.</p>
                                        }
                                    </Dropzone>
                                </div>
                            </div>
                        </div>
                        {this.renderModalFooter()}
                    </div>
                </div>
            </div>
        )
    };
}

ModalAddAnotherSubject.propTypes = {
    courses: PropTypes.array,
    addNewSubject: PropTypes.func.isRequired,
    resetSubjectState: PropTypes.func.isRequired
};

export default ModalAddAnotherSubject;


// WEBPACK FOOTER //
// ./src/components/AdminPanel/ModalAddAnotherSubject.js